export default "__VITE_ASSET__yj4Tx4A___"